import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { PasswordParams } from '../../models/password-params';
import { Partner } from '../../models/partner';
import { NotificationService } from '../../../general/services/notification.service';
import { PartnerFieldsConfigurations } from '../../models/partner-fields-configuration';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';

@Component({
  selector: 'app-partner-registration-form',
  templateUrl: './partner-registration-form.component.html',
  styleUrls: ['./partner-registration-form.component.css']
})
export class PartnerRegistrationFormComponent implements OnInit, OnDestroy {

  @Input()
  partner = new Partner();

  @Input()
  password = new PasswordParams();

  @Input()
  showPassword: boolean;

  @Input()
  isRegistrationEnabled: boolean;

  @Input()
  showLoginUrl = true;

  @Input()
  fieldsConfigurations: PartnerFieldsConfigurations;

  private _error: string;
  @Input() set error(value: string) {
    this._error = value;
    this.notificationService.show(PartnerRegistrationFormComponent.name, value);
  }

  @Input()
  fullSize: string;

  @Output()
  eventRegister = new EventEmitter();

  @Output()
  eventLogin = new EventEmitter();

  @Output()
  eventBack = new EventEmitter();

  @Input()
  showBack: boolean;

  constructor(
    private notificationService: NotificationService,
    private shopSettingsService: ShopSettingsService,
    ) {

  }

  ngOnInit(): void {
  }

  onRegistrationDataValid(): void {
    this.isRegistrationEnabled = true;
  }

  onRegistrationDataInvalid(): void {
    this.isRegistrationEnabled = false;
  }

  onBack(): void {
    this.eventBack.emit();
  }

  onRegister(): void {
    this.eventRegister.emit();
  }

  onLogin(): void {
    this.eventLogin.emit();
  }

  ngOnDestroy(): void {
    this.notificationService.hide(PartnerRegistrationFormComponent.name);
  }

  get showTermsConditionsLink(): boolean {
    return this.shopSettingsService?.shopSettings?.showTermsConditionsLink;
  }

  get showInternalReference(): boolean {
    return this.shopSettingsService?.isRegistrationByPartnerRefValidate;
  }
}
